export default __webpack_public_path__ + "static/media/logo.df2f1df8.png";